import React from "react";
import store from "store";
import $ from "jquery";
import Page from "../Page";
import {
  API_COURSE_BASE_URL,
  API_QUIZ_BASE_URL,
  BASE_URL,
  CheckAuth,
  PRETEST_TITLE,
} from "../Util";
import { Col, Icon, Row } from "react-materialize";
import { Link } from "react-router-dom";
import Image from "../Image";
import QuizHeader from "./Header";
import { trans } from "../Lang";
import RatingModal from "../Reuseables/RatingModal";
import "../../styles/course-rating-modal.css";
import { QuizRecap } from "./Recap";

class QuizResult extends Page {
  constructor(props) {
    super(props);
    this.state = {
      data: false,
      quiz_uuid: props.match.params.uuid,
      recap: props.match.params.recap,
    };
  }

  componentDidMount() {
    this.handleLoadData();
    super.componentDidMount();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.data && !prevState.data) {
      $.get(API_COURSE_BASE_URL + this.state.data.course_slug).then((reply) => {
        this.setState({ course_detail: reply.payload });
      });
    }
  }

  componentWillReceiveProps(props) {
    this.setState({ recap: props.match.params.recap });
    super.componentWillReceiveProps(props);
  }

  handleLoadData = (e) => {
    const storedResultData = store.get(`result_${this.state.quiz_uuid}`);
    if (storedResultData) {
      console.log("Quiz result from storage", storedResultData);
      this.setState({ data: storedResultData });
      return;
    }

    $.get(API_QUIZ_BASE_URL + this.state.quiz_uuid + "/submissions")
      .then((data) => {
        console.log("Quiz result from api >>> ", data.payload);
        this.setState({ data: data.payload });
      })
      .fail((err) => console.log("ERROR >>> ", err));
  };

  render() {
    var { data, course_detail } = this.state;
    let rating_specs = [
      { topic: "Materi Kursus", name: "rating_content", item: "modul" },
      { topic: "Kualitas Media", name: "rating_media", item: "modul" },
      {
        topic: "Benefit yang Anda rasakan",
        name: "rating_benefit",
        item: "modul",
      },
    ];

    let comment_rating_specs = [
      {
        title: "Tuliskan Masukan Anda",
        placeholder: "Masukan Anda",
        name: "user_comment",
        rows: 6,
      },
    ];

    /*if (this.state.recap === 'recap') {
			return <QuizRecap result={data} />
		}*/

    var score = Math.round(
      (data.correct_answer_count * 100) / data.question_count
    );
    var pass = data ? score >= data.pass_mark : null;
    var actionBtn = (
      <Link to={`/quiz/${data.quiz_uuid}`} className="btn full-s capitalize">
        Ulang Kuis
      </Link>
    );
    var resultText = "";

    if (pass) {
      //console.log('test');
      if (data.is_last_chapter) {
        actionBtn = (
          <Link
            to={`/course/${data.course_uuid}/certificate`}
            className="btn full-s capitalize"
          >
            {trans.certificate}
          </Link>
        );

        actionBtn = (
          <Link
            to={`/course/${data.course_slug}`}
            // to={`/course/${data.course_uuid}#${data.uuid}`}
            className="btn full-s capitalize"
          >
            Kembali ke {trans.course}
          </Link>
        );
        resultText = (
          <div>
            Selamat Anda telah menyelesaikan seluruh {trans.chapter} dari{" "}
            {trans.course} ini.
            <br />
            <br />
            Kami memberikan {trans.certificate} sebagai bukti Anda telah lulus
            melewati pembelajaran dan ujian.
          </div>
        );
      } else {
        actionBtn = (
          <Link
            to={`/course/${data.course_slug}`}
            // to={`/course/${data.course_uuid}#${data.uuid}`}
            className="btn full-s capitalize"
          >
            Lanjut {trans.chapter}
          </Link>
        );
        resultText = (
          <div>
            Selamat Anda menyelesaikan
            <br />
            Kuis pada Chapter ini<p className="font-small">{data.title}</p>
            <h4>{data.chapter_title}</h4>
          </div>
        );
      }
    } else {
      if (data.is_last_chapter) {
        resultText = (
          <div>
            Sayang sekali Anda belum dinyatakan lulus dari {trans.course} ini.
            Namun jangan khawatir, kami memberikan kesempatan untuk ujian ulang.
            Dan Anda dapat membuka kembali materi-materi&nbsp;
            <Link to={`/course/${data.course_slug}`} className="font-orange">
              sebelumnya
            </Link>
          </div>
        );
      } else {
        resultText = `Mohon maaf, Anda belum dinyatakan lulus dari kuis pada ${trans.chapter} ini. Namun, Anda bisa mempelajari lagi materi-materi yang ada dan mengulang kuis kembali.`;
      }
    }

    return (
      <div>
        {course_detail && (
          <RatingModal
            header="Review Kursus"
            rating_specs={rating_specs}
            comment_specs={comment_rating_specs}
            modal_name="course_rating"
            is_open={
              data.is_passed &&
              data.is_last_chapter &&
              !course_detail.has_reviewed &&
              course_detail.ask_to_review
            }
            api_url={API_COURSE_BASE_URL + data.course_uuid + "/review"}
          />
        )}

        <QuizHeader data={data} />
        <div className="bg-gradient pad-l center">
          <div className="container-small">
            <Image className="medium circle centered" src={CheckAuth().foto} />
            <br />
            {data && pass != null ? (
              <h4 className="font-white">
                {!pass && "BELUM"}{" "}
                {data.title == PRETEST_TITLE
                  ? "Langkah Pertama Anda !"
                  : "LULUS!"}
              </h4>
            ) : null}

            {pass && (
              <img className="convetti" src={BASE_URL + "/img/convetti.png"} />
            )}
          </div>
        </div>
        <div className="bg-white pad-m center">
          <div className="container-small pad-l">
            <Row>
              <Col className="offset-m3 center" m={3} s={6}>
                <Icon className="font-orange mb-s" medium>
                  check_circle
                </Icon>
                <h4>
                  {data.correct_answer_count} / {data.question_count}
                </h4>
                <h5 className="font-grey font-light">Pertanyaan</h5>
              </Col>
              <Col className="center" m={3} s={6}>
                <Icon className="font-orange mb-s" medium>
                  timeline
                </Icon>
                <h4>{score} %</h4>
                <h5 className="font-grey font-light">Nilai Anda</h5>
              </Col>
            </Row>
            <hr className="mtb-m" />
            <p className="h5 font-light centered max-400 pb-m">{resultText}</p>
            <Link
              className="btn capitalize btn-outline full-s"
              to={{
                pathname: `/quiz/result/${data.quiz_uuid}/recap`,
                state: { quiz_result: data },
              }}
            >
              Ulasan
            </Link>
            &nbsp; {actionBtn}
          </div>
        </div>
      </div>
    );
  }
}
export default QuizResult;



// WEBPACK FOOTER //
// ./src/components/Quiz/Result.js